module.exports = __webpack_public_path__ + "img/image02.d3430e82.png";